import * as cheerio from "cheerio";
import { Api } from "telegram";

export default function extractEntities(messageInHTML) {
  const tagsLength = {
    b: 7,
    a: 15,
    code: 13,
  };

  const messageAdapted = messageInHTML.replace(/&#39;/g, "'")

  const $ = cheerio.load(messageAdapted);
  const messageEntities = [];

  const cleanText = $.root().text();
  // Extract only the text content from the HTML
  let bTagsFound = 0;
  let aTagsFound = 0;
  let codeTagsFound = 0;
  let linksLength = 0;

  $("b, a, i, u, code").each((index, element) => {
    const tagHtml = $(element).html();
    const length = tagHtml.length;

    const cumulativeOffset =
      bTagsFound * tagsLength.b +
      aTagsFound * tagsLength.a +
      linksLength +
      codeTagsFound * tagsLength.code;

    if ($(element).is("b")) {
      messageEntities.push(
        new Api.MessageEntityBold({
          offset: messageAdapted.indexOf(`<b>${tagHtml}</b>`) - cumulativeOffset,
          length,
        }),
      );
      bTagsFound += 1;
    } else if ($(element).is("a")) {
      const url = $(element).attr("href");
      if (url && url.startsWith("http")) {
        const hrefToSearch = `<a href="${url}">${tagHtml}</a>`

        messageEntities.push(
          new Api.MessageEntityTextUrl({
            offset:messageAdapted.indexOf(hrefToSearch) - cumulativeOffset,
            length,
            url,
          }),
        );
      }
      linksLength += url.length;
      aTagsFound += 1;
    } else if ($(element).is("code")) {
      messageEntities.push(
        new Api.MessageEntityCode({
          offset:messageAdapted.indexOf(`<code>${tagHtml}</code>`)  - cumulativeOffset,
          length,
        }),
      );
      codeTagsFound += 1;
    } else if ($(element).is("i")) {
      messageEntities.push(
        new Api.MessageEntityItalic({
          offset: messageAdapted.indexOf(`<i>${tagHtml}</i>`) - cumulativeOffset,
          length,
        }),
      );
      bTagsFound += 1;
    } else if ($(element).is("u")) {
      messageEntities.push(
        new Api.MessageEntityUnderline({
          offset: messageAdapted.indexOf(`<u>${tagHtml}</u>`) - cumulativeOffset,
          length,
        }),
      );
      bTagsFound += 1;
    }
  });

  return { msg: cleanText, messageEntities };
}
